import React, { Children, ReactNode } from 'react';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

const MAX_VISIBLE_ITEMS = 20;

interface FilterToggleWrapperProps {
  children?: ReactNode;
  maxItems?: number;
  className?: string;
}

const Wrapper = styled.div.attrs({
  role: 'group',
  'aria-label': 'Selected filters',
})`
  background: transparent;
  border: none;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const MoreIndicator = styled.span`
  display: inline-block;
  color: ${colorScheme.buttons.gray.text};

  font-size: 12px;
  line-height: 14px;
  font-weight: 400;

  background: ${colorScheme.divider};
  text-align: center;
  border-radius: 4px;
  padding: 4px 8px;

  color: ${colorScheme.brand};
  margin-right: 8px;
  margin-bottom: 4px;
`;

export function FilterToggleWrapper({ children, className, maxItems = MAX_VISIBLE_ITEMS }: FilterToggleWrapperProps) {
  const childArray = Children.toArray(children);
  const totalCount = childArray.length;
  const hasMore = totalCount > maxItems;
  const visibleChildren = hasMore ? childArray.slice(0, maxItems) : childArray;
  const hiddenCount = totalCount - maxItems;

  return (
    <Wrapper className={className}>
      {visibleChildren}
      {hasMore && <MoreIndicator>+ {hiddenCount} more</MoreIndicator>}
    </Wrapper>
  );
}
